var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto my-4 v-image__image--cover d-flex justify-center align-center flex-column",style:({
  backgroundImage:`url('${_vm.img}')`,
  width:'95%',
  height:'540px'

})},[_c('h2',{class:['font-weight-bold',this.$route.path.indexOf('glass')>0? 'primary--text':'green--text'],attrs:{"dir":"auto"}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"px-4",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }